import * as yup from 'yup';

export const commercialDefaultValues = {
  vat_number: '',
  turnover_value: '',
  number_of_employees: '',
  payment_frequency: 2, // default to annual
  sub_product: 'commercial_basic',
  effective_date: '',
  payment_frequency_value: '01',
  property_value: '',
  privacies: [],
  attpr_value: '',
  coverages: [
    {
      coverage_code: 'RCT',
      parameter_collections: [
      ],
    },
    {
      coverage_code: 'CONT',
      parameter_collections: [],
    },
    {
      coverage_code: 'RTER',
      parameter_collections: [],
    },
    {
      coverage_code: 'REFR',
      parameter_collections: [],
    },
    {
      coverage_code: 'CRIS',
      parameter_collections: [],
    },
    {
      coverage_code: 'CONT.F',
      parameter_collections: [],
    },
    // {
    //   coverage_code: 'PROP',
    //   parameter_collections: [],
    // },
    {
      coverage_code: 'ELE',
      parameter_collections: [],
    },
    // {
    //   coverage_code: 'INCI',
    //   parameter_collections: [],
    // },
  ],
  technical_location_data: {
    annor_value: null,
    annoc_value: null,
    tpab_value: '',
    attpr_value: '',
  },
  gender: 'G',
  company_name: '',
  address: {
    address_type: 6,
    postal_code: '',
    address: '',
    house_number: '',
    ministerial_municipality_code: '',
    municipality_name: '',
    province_code: '',
    country_code_uic: '',
    main_address_flag: 'S',
    commercial_company_id: null,
  },
  location_and_structures: {
    proximity_to_water_bodies: null,
    proximity_to_fragile_slopes_or_landslide_areas: null,
    elevation_above_ground_level: null,
    proximity_to_major_transport_routes: null,
    presence_of_groundwater: null,
    presence_of_basements_or_semi_basements: null,
    presence_of_shelving: null,
    non_seismic_roof_configuration: null,
    beams_anchored_to_pillars: null,
    presence_of_electrical_transformer_rooms: null,
    presence_of_thermal_power_station: null,
    presence_of_air_compressors: null,
    presence_of_refrigeration_units: null,
    combustible_building_materials: null,
    presence_of_confined_spaces: null,
    data_processing_equipment_in_basement: null,
    presence_of_classic_sandwich_panels: null,
    roof_supporting_structure_material: '',
  },
  infrastructure_and_machines: {
    sewer_level_above_public_sewers: null,
    electrical_system_pre_1990: null,
    damage_risk_to_equipment_due_to_power_outage: null,
    damage_risk_to_computers_due_to_power_outage: null,
    it_system_essential_for_continuity: null,
    presence_of_combustible_packaging: null,
    presence_of_expanded_plastic_packaging: null,
    use_of_flammable_gases: null,
    staff_present_during_closure: null,
    explosion_risk: null,
    firefighter_response_time_under_15_minutes: null,
    staff_present_at_night: null,
    valuable_goods_storage: null,
    use_of_forklifts_or_load_handling_systems: null,
    risk_of_exposure_to_carcinogens: null,
    use_of_chemicals: null,
    presence_of_underground_tanks_with_non_water_substances: null,
    machinery_using_oil: null,
    concrete_or_resin_flooring: null,
    use_or_storage_of_flammable_solvents: null,
    use_of_open_flames: null,
    goods_sensitive_to_humidity: null,
    machinery_sensitive_to_humidity: null,
    presence_of_structures_like_chimneys_towers_silos_tanks: null,
    use_of_unique_machinery_for_production: null,
    use_of_custom_machinery: null,
    machinery_no_longer_in_production: null,
    possibility_to_modify_process_with_alternative_machinery: null,
    machinery_exposed_to_corrosive_environments: null,
    machinery_in_dusty_environments: null,
    backup_for_critical_machinery: null,
    use_of_biting_machines: null,
    equipment_or_material_with_long_replacement_time: null,
  },
  security_and_logistics: {
    contains_easily_resellable_goods: null,
    contains_hard_to_identify_goods: null,
    frequent_access_by_non_staff: null,
    contains_easily_transportable_goods: null,
    reported_occupational_illnesses: null,
    third_party_access_for_installations_or_services: null,
    provides_installations_or_services_at_third_party_locations: null,
    stores_third_party_goods: null,
    high_value_domestic_transported_goods: null,
    high_value_international_transported_goods: null,
    ships_perishable_goods: null,
    subject_to_hazardous_material_transport_regulations: null,
    uses_contract_logistics_providers: null,
  },
  product_and_its: {
    company_branding_on_products: null,
    imports_into_eu: null,
    sells_in_us_canada_mexico: null,
    perishable_products: null,
    products_use_electricity: null,
    products_use_combustible_gases: null,
    provides_installation_and_maintenance: null,
    presence_of_special_goods: null,
    process_bottlenecks: null,
    vulnerability_to_wetting: '',
    easy_to_move_goods_away_from_wet: null,
    high_workspace_utilization: '',
    operates_in_large_distribution_chain: null,
    adequately_stocked_spare_parts_warehouse: null,
    critical_business_documents: null,
    possibility_of_increasing_work_shifts: null,
    disaster_recovery_and_business_continuity_system: null,
    remote_access_to_information_system: null,
    backup_communication_system: null,
    adopted_organizational_models_for_crisis_management: null,
  },
  finance_and_personals: {
    credit_system_based_on_risk: null,
    payment_methods_minimize_exposure: null,
    bank_credit_utilization_above_60_percent: null,
    seasonal_or_periodic_revenue_fluctuations: null,
    inventory_volatility_above_20_percent: null,
    subsidiaries_in_eu_or_switzerland: null,
    key_personnel_for_strategy: null,
    key_personnel_for_production: null,
    key_personnel_with_exclusive_client_relationships: null,
    locations_or_employees_outside_eu_norway_switzerland: null,
    executives_own_company_shares: null,
    conflict_of_interest_with_consulting_firms: null,
    sponsorship_contracts: null,
    defined_organizational_chart_and_governance: null,
    public_exposure_of_brand: null,
  },
  complete_questionario: null,
};

export const building_type = [
  // removed from options // ticket-1313
  // {
  //   id: '01',
  //   name: 'Abitazione Singola',
  // },
  // {
  //   id: '02',
  //   name: 'Villa a Schiera',
  // },
  // {
  //   id: '03',
  //   name: 'Condominio',
  // },
  // {
  //   id: '04',
  //   name: 'Industriale',
  // },
  // {
  //   id: '00005',
  //   name: 'Fabbricato Industriale a Più Campate',
  // },
  // {
  //   id: '00006',
  //   name: 'Fabbricato ad Unico Piano',
  // },
  {
    id: '07',
    name: 'Fabbricato di Proprietà',
  },
  {
    id: '08',
    name: 'Fabbricato in Locazione',
  },
];

export const main_activities = [
  {
    id: '000RRR',
    name: 'ATTIVITÀ NON CODIFICATA',
  },
  {
    id: '001CAA',
    name: 'ABBIGLIAMENTO IN GENERE',
  },
  {
    id: '002CBB',
    name: 'ACCESSORI/RICAMBI AUTOMOTOVEICOLI E NATANTI:NO FONOAUDIOVISIVI',
  },
  {
    id: '003CAB',
    name: 'ACCESSORI/RICAMBI AUTOMOTOVEICOLI E NATANTI:SI FONOAUDIOVISIVI',
  },
  {
    id: '004ADB',
    name: 'ACQUE GASSATE E MINERALI',
  },
  {
    id: '005ABB',
    name: 'ALIMENTARI IN GENERE',
  },
  {
    id: '006CDB',
    name: 'ANIMALI VIVI',
  },
  {
    id: '007CAA',
    name: 'ANTICHITÀ ED ARTE, ESCLUSI PREZIOSI',
  },
  {
    id: '008CAA',
    name: 'APPARECCHI CINEMATOGRAFICI, FOTOGRAFICI ED OTTICI',
  },
  {
    id: '009BDA',
    name: 'APPARECCHI ORTOPEDICI',
  },
  {
    id: '010BCA',
    name: 'APPARECCHI TECNICI E SCIENTIFICI (ESCLUSI FOTO-OTTICI)',
  },
  {
    id: '011DCA',
    name: 'APPARECCHI DOMESTICI A GAS',
  },
  {
    id: '012CBA',
    name: 'ARAZZI',
  },
  {
    id: '013AAA',
    name: 'ARGENTERIA',
  },
  {
    id: '014DAB',
    name: 'ARMI, COMPRESE MUNIZIONI',
  },
  {
    id: '015CAB',
    name: 'ARMI, ESCLUSE MUNIZIONI',
  },
  {
    id: '016CCA',
    name: 'ARTICOLI DA REGALO',
  },

  {
    id: '017CDB',
    name: 'ARTICOLI MEDICALI, IGIENICI E SANITARI (NO MEDICINALI E STUPEFACENTI)',
  },
  {
    id: '018CDA',
    name: 'ARTICOLI RELIGIOSI (ESCLUSI PREZIOSI ED ARGENTERIA)',
  },
  {
    id: '019CBA',
    name: 'ARTICOLI SPORTIVI, ESCLUSO ABBIGLIAMENTO',
  },
  {
    id: '020CAA',
    name: 'ARTICOLI SPORTIVI, COMPRESO ABBIGLIAMENTO',
  },
  {
    id: '021ACA',
    name: 'AUTOVEICOLI (ESPOSIZIONE E VENDITA)',
  },
  {
    id: '022BBA',
    name: 'BAR, SENZA PRODUZIONE PROPRIA DI GELATERIA/PASTICCERIA',
  },
  {
    id: '023BBB',
    name: 'BAR, ANCHE CON PRODUZIONE PROPRIA DI GELATERIA/PASTICCERIA',
  },
  {
    id: '024BDB',
    name: 'BARBIERE',
  },
  {
    id: '025CCA',
    name: 'BARCHE, BATTELLI, MOTOSCAFI',
  },
  {
    id: '026DAA',
    name: 'BAZAR, ESCLUSI PREZIOSI',
  },
  {
    id: '027CDA',
    name: 'BERRETTI E CAPPELLI, NON DI PAGLIA',
  },
  {
    id: '028CAA',
    name: 'BIANCHERIA PER ABBIGLIAMENTO',
  },
  {
    id: '029CBA',
    name: 'BIANCHERIA DA CASA',
  },
  {
    id: '030BDB',
    name: 'BIBITE IN GENERE',
  },
  {
    id: '031ACB',
    name: 'BICICLETTE (ESPOSIZIONE E VENDITA)',
  },
  {
    id: '032ACA',
    name: 'BIGIOTTERIA, ESCLUSI PREZIOSI E ARGENTO',
  },
  {
    id: '033CDB',
    name: 'BILIARDI',
  },
  {
    id: '034CCB',
    name: 'BILIARDINI ELETTRICI, JUKE-BOX E SIMILI',
  },
  {
    id: '035BCA',
    name: 'BIRRERIA',
  },
  {
    id: '036CAA',
    name: 'CALCOLATORI ELETTRONICI',
  },
  {
    id: '037CBA',
    name: 'CALZATURE IN GENERE',
  },
  {
    id: '038CBB',
    name: 'CALZOLAIO SU MISURA',
  },
  {
    id: '039CAA',
    name: 'CAMICERIA',
  },
  {
    id: '040DBB',
    name: 'CAMPEGGIO (ARTICOLI PER)',
  },
  {
    id: '041BCA',
    name: 'CANCELLERIA (ARTICOLI DI)',
  },
  {
    id: '042BBB',
    name: 'CARNI IN GENERE, ESCLUSI INSACCATI',
  },
  {
    id: '043CBB',
    name: 'CARNI INSACCATE E CONSERVATE',
  },
  {
    id: '044CDA',
    name: 'CARTA DA PARATI',
  },
  {
    id: '045CDA',
    name: 'CARTA E CARTONE (OGGETTI DI) - CARTOTECNICA',
  },
  {
    id: '046BBA',
    name: 'CARTOLERIA - CARTOLIBRERIA (ESCLUSI PREZIOSI E ARGENTO)',
  },
  {
    id: '047BCA',
    name: 'CASALINGHI, ESCLUSI ELETTRODOMESTICI IN GENERE',
  },
  {
    id: '048CAA',
    name: 'CASALINGHI, COMPRESI ELETTRODOMESTICI ANCHE AUDIOVISIVI',
  },
  {
    id: '049BCA',
    name: 'CASSEFORTI',
  },
  {
    id: '050BCA',
    name: 'CERAMICHE, MAIOLICHE, PORCELLANE',
  },
  {
    id: '051CCB',
    name: 'CIABATTINO',
  },
  {
    id: '052BCB',
    name: 'CICLI E MOTOCICLI (ANCHE CON RIPARAZIONE)',
  },
  {
    id: '053CBA',
    name: 'COLONIALI',
  },
  {
    id: '054CDA',
    name: 'COLORI, COLORANTI, IDROPITTURE (ESCLUSI SMALTI E VERNICI)',
  },
  {
    id: '055BBB',
    name: 'COLTELLI, POSATE, ARMI BIANCHE (ESCLUSO ARGENTO)',
  },
  {
    id: '056CDB',
    name: 'CONCIMI E FERTILIZZANTI',
  },
  {
    id: '057CBA',
    name: "CONDIZIONATORI D'ARIA",
  },
  {
    id: '058BBB',
    name: 'CONFETTURE E CONSERVE ALIMENTARI',
  },
  {
    id: '059BCA',
    name: 'COPISTERIA - FOTOCOPIE',
  },
  {
    id: '060CDB',
    name: 'CORNICI',
  },
  {
    id: '061CDA',
    name: 'CORSETTERIA',
  },
  {
    id: '062CBA',
    name: 'CRAVATTE',
  },
  {
    id: '063BDA',
    name: 'CRISTALLI, SPECCHI E VETRI',
  },
  {
    id: '064CAA',
    name: 'CUOIO (ARTICOLI DI)',
  },
  {
    id: '065BBA',
    name: 'CUSCINETTI A RULLI O A SFERE',
  },
  {
    id: '066BDA',
    name: 'DAMIGIANE, FIASCHI E SIMILI',
  },
  {
    id: '067CCA',
    name: 'DETERSIVI E DETERGENTI',
  },
  {
    id: '068CBA',
    name: 'DISCHI FONOGRAFICI, C.D., AUDIO-VIDEO CASSETTE, COMPRESO NOLEGGIO',
  },
  {
    id: '069DDA',
    name: 'DISEGNI, GARBI E MODELLI',
  },
  {
    id: '070BBB',
    name: 'DOLCIUMI',
  },
  {
    id: '071CBB',
    name: 'DROGHERIA',
  },
  {
    id: '072CBA',
    name: 'ELETTRAUTO, ESCLUSI APPARECCHI FONOAUDIOVISIVI',
  },
  {
    id: '073CBA',
    name: 'ELETTRICITÀ (ARTICOLI E MATERIALI), ESCLUSI FONOAUDIOVISIVI',
  },
  {
    id: '074CAA',
    name: 'ELETTRODOMESTICI - COMPRESI FONOAUDIOVISIVI E LORO RICAMBI',
  },
  {
    id: '075CBA',
    name: 'ELETTRODOMESTICI - ESCLUSI FONOAUDIOVISIVI E LORO RICAMBI',
  },
  {
    id: '076CAA',
    name: 'ELETTRONICA (MACCHINE, STRUMENTI, APPARECCHIATURE, ECC.)',
  },
  {
    id: '077BCA',
    name: 'ERBIVENDOLO',
  },
  {
    id: '078DCB',
    name: 'ERBORISTERIA',
  },
  {
    id: '079BDB',
    name: 'ESTETISTA - VISAGISTA',
  },
  {
    id: '080CBB',
    name: 'FARMACIA (ESCLUSI STUPEFACENTI)',
  },
  {
    id: '081BCA',
    name: 'FERRAMENTA',
  },
  {
    id: '082CDA',
    name: 'FIGURINISTA E MODELLISTA',
  },
  {
    id: '083CAA',
    name: 'FILATELIA E NUMISMATICA (ESCLUSI PREZIOSI)',
  },
  {
    id: '084CBA',
    name: 'FILATI IN GENERE',
  },
  {
    id: '085DDA',
    name: 'FIORAIO',
  },
  {
    id: '086BBB',
    name: 'FORMAGGI IN GENERE, DURI E MOLLI',
  },
  {
    id: '087BCB',
    name: 'FORMAGGI MOLLI',
  },
  {
    id: '088CBA',
    name: 'FOTOGRAFO (STUDIO DI)',
  },
  {
    id: '089BDA',
    name: 'FRUTTA E ORTAGGI FRESCHI',
  },
  {
    id: '090BBA',
    name: 'FRUTTA E ORTAGGI FRESCHI, SECCHI E IN SCATOLA',
  },
  {
    id: '091CBB',
    name: 'GASTRONOMIA',
  },
  {
    id: '092BCA',
    name: 'GELATERIA E CREMERIA, SENZA PRODUZIONE PROPRIA',
  },
  {
    id: '093BCB',
    name: 'GELATERIA E CREMERIA, CON PRODUZIONE PROPRIA',
  },
  {
    id: '094DCA',
    name: 'GIOCATTOLI, ESCLUSI, QUELLI PIRICI',
  },
  {
    id: '095BXA',
    name: 'GIOIELLERIA',
  },
  {
    id: '096CDA',
    name: 'GIORNALI E RIVISTE',
  },
  {
    id: '097CDB',
    name: 'GOMMA (OGGETTI DI)',
  },
  {
    id: '098CDA',
    name: 'GRANAGLIE E CEREALI',
  },
  {
    id: '099CBA',
    name: 'GUANTI, ESCLUSI PELLI E PELLAMI',
  },
  {
    id: '100BCA',
    name: 'IDRAULICI (MATERIALE PER)',
  },
  {
    id: '101ACA',
    name: 'IDROTERMOSANITARI (APPARECCHI E MATERIALI)',
  },
  {
    id: '102BDA',
    name: 'LAMIERE, LAMIERINI, LAMINATI METALLICI',
  },
  {
    id: '103CDA',
    name: 'LAMPADARI - PARALUMI',
  },
  {
    id: '104CCB',
    name: 'LAMPADE ELETTRICHE E TUBI FLUORESCENTI E LUMINESCENTI',
  },
  {
    id: '105BCB',
    name: 'LATTERIE, LATTICINI, ESCLUSI FORMAGGI DURI',
  },
  {
    id: '106CBC',
    name: 'LAVANDERIA E STIRERIA, ESCLUSI CAPI IN PELLE E PELLICCE',
  },
  {
    id: '107BDA',
    name: 'LIBRERIA, ESCLUSO ANTIQUARIATO',
  },
  {
    id: '108CAA',
    name: 'LIBRERIA, COMPRESO ANTIQUARIATO',
  },
  {
    id: '109CCA',
    name: 'LUBRIFICANTI (OLI E GRASSI)',
  },
  {
    id: '110BAA',
    name: 'MACCHINE PER SCRIVERE E CALCOLARE',
  },
  {
    id: '111BBA',
    name: 'MACCHINE PER DUPLICARE E FOTOCOPIARE',
  },
  {
    id: '112BBB',
    name: 'MACCHINE PER CUCIRE',
  },
  {
    id: '113BDB',
    name: 'MACCHINE E MECCANISMI AGRICOLI, EDILI, STRADALI, INDUSTRIALI',
  },
  {
    id: '114BDA',
    name: 'MACCHINE PER CAFFÈ',
  },
  {
    id: '115ABB',
    name: 'MACELLERIA',
  },
  {
    id: '116CAA',
    name: 'MAGLIERIA',
  },
  {
    id: '117ACB',
    name: 'MAIOLICHE - PORCELLANE - CERAMICHE',
  },
  {
    id: '118DDB',
    name: 'MANGIMI',
  },
  {
    id: '119ADA',
    name: 'MARMO E AFFINI',
  },
  {
    id: '120DCB',
    name: 'MATERASSI',
  },
  {
    id: '121CAA',
    name: 'MERCERIA, COMPRESO ABBIGLIAMENTO',
  },
  {
    id: '122CBA',
    name: 'MERCERIA, ESCLUSO ABBIGLIAMENTO',
  },
  {
    id: '123CAC',
    name: 'MINIMARKET',
  },
  {
    id: '124ADA',
    name: 'MINUTERIE METALLICHE',
  },
  {
    id: '125CCB',
    name: 'MOBILI IN GENERE, ESCLUSI QUELLI DI ANTIQUARIATO',
  },
  {
    id: '126ADB',
    name: 'MOBILI DI SOLO METALLO',
  },
  {
    id: '127DBA',
    name: 'MODELLISTA E FIGURINISTA',
  },
  {
    id: '128CBA',
    name: 'MODISTERIA',
  },
  {
    id: '129CCB',
    name: 'MOTOSCAFI, BARCHE E BATTELLI',
  },
  {
    id: '130CCB',
    name: 'OLI ALIMENTARI, ANIMALI E VEGETALI',
  },
  {
    id: '131DCA',
    name: 'OLI LUBRIFICANTI E MINERALI',
  },
  {
    id: '132BXA',
    name: 'OREFICERIA, OROLOGERIA',
  },
  {
    id: '133CDA',
    name: 'ORTOPEDIA (ARTICOLI PER)',
  },
  {
    id: '134BBB',
    name: 'OSTERIA',
  },
  {
    id: '135CCB',
    name: 'PANETTERIA CON FORNO NON CONTINUO',
  },
  {
    id: '136ACA',
    name: 'PANETTERIA SENZA FORNO',
  },
  {
    id: '137BDB',
    name: 'PARRUCCHIERE',
  },
  {
    id: '138BCB',
    name: 'PASTAIO (PASTA ALIMENTARE FRESCA)',
  },
  {
    id: '139BCB',
    name: 'PASTE ALIMENTARI',
  },
  {
    id: '140CCB',
    name: 'PASTICCERIA CON FORNO NON CONTINUO',
  },
  {
    id: '141BCA',
    name: 'PASTICCERIA SENZA FORNO',
  },
  {
    id: '142CAA',
    name: 'PELLETTERIA',
  },
  {
    id: '143CXA',
    name: 'PELLICCERIA',
  },
  {
    id: '144ADB',
    name: 'PESCHERIA',
  },
  {
    id: '145CBB',
    name: 'PIZZERIA',
  },
  {
    id: '146DBA',
    name: 'PNEUMATICI',
  },
  {
    id: '147BBB',
    name: 'POLLERIA MORTA - CACCIAGIONE',
  },
  {
    id: '148DCA',
    name: 'POLTRONE E DIVANI',
  },
  {
    id: '149ACB',
    name: 'PORCELLANA - MAIOLICA - CERAMICA',
  },
  {
    id: '150CBA',
    name: 'PROFUMERIA',
  },
  {
    id: '151CDA',
    name: 'RILEGATORIA (ESCLUSO ANTIQUARIATO)',
  },
  {
    id: '152CBB',
    name: 'RISTORANTE',
  },
  {
    id: '153CBB',
    name: 'ROSTICCERIA',
  },
  {
    id: '154CCA',
    name: 'ROULOTTES (VENDITA ED ESPOSIZIONE)',
  },
  {
    id: '155BCA',
    name: 'RUBINETTERIE IN METALLO',
  },
  {
    id: '156CBB',
    name: 'SALUMERIA',
  },
  {
    id: '157BCA',
    name: 'SAPONI, SAPONETTE, SAPONI LIQUIDI ED IN POLVERE',
  },
  {
    id: '158CAA',
    name: 'SARTORIA SU MISURA',
  },
  {
    id: '159CAA',
    name: 'SELLERIA E FINIMENTI',
  },
  {
    id: '160BDA',
    name: 'SEMENTI IN GENERE',
  },
  {
    id: '161DDA',
    name: 'SERRAMENTI, ANCHE AVVOLGIBILI, IN LEGNO E PLASTICA',
  },
  {
    id: '162ADA',
    name: 'SERRAMENTI, ANCHE AVVOLGIBILI, IN METALLO',
  },
  {
    id: '163BCA',
    name: 'SERRATURE E LUCCHETTI',
  },
  {
    id: '164BDA',
    name: 'SPECCHI, VETRI E CRISTALLI',
  },
  {
    id: '165CBC',
    name: 'STIRERIA',
  },
  {
    id: '166CAA',
    name: 'STOFFE PER ABBIGLIAMENTO',
  },
  {
    id: '167CBA',
    name: 'STOFFE PER ARREDAMENTO',
  },
  {
    id: '168CBA',
    name: 'STRUMENTI MUSICALI E LORO ACCESSORI',
  },
  {
    id: '169BBB',
    name: 'SURGELATI (ALIMENTARI)',
  },
  {
    id: '170CXA',
    name: 'TABACCHERIA',
  },
  {
    id: '171CBA',
    name: "TAPPETI, ESCLUSI QUELLI D'ARTE E ANTIQUARIATO",
  },
  {
    id: '172CBA',
    name: 'TAPPEZZERIE DI CARTA, PLASTICA E TESSUTI',
  },
  {
    id: '173CDA',
    name: 'TAPPEZZERIE DI SOLA CARTA E PLASTICA',
  },
  {
    id: '174CBB',
    name: 'TENDE E ARTICOLI DA CAMPEGGIO',
  },
  {
    id: '175CBB',
    name: 'TRATTORIA',
  },
  {
    id: '176BBA',
    name: 'UTENSILERIA METALLICA',
  },
  {
    id: '177CAA',
    name: 'VALIGERIE',
  },
  {
    id: '178DDA',
    name: 'VERNICI E SMALTI (ESCLUSI INFIAMMABILI)',
  },
  {
    id: '179RDA',
    name: 'VERNICI E SMALTI (COMPRESI INFIAMMABILI)',
  },
  {
    id: '180CBA',
    name: 'VINI E LIQUORI',
  },
  {
    id: '181BCA',
    name: 'ZUCCHERO E SUOI SURROGATI',
  },
];

export const commercial_goods = [
  {
    id: 'RCT',
    name: 'Responsabilità Civile',
    parameter_collections: [
      {
        id: 1,
        name: 'Massimale',
        values: [
          { id: 1, name: '500.000,00€' },
          { id: 2, name: '1.000.000,00€' },
          { id: 3, name: '1.500.000,00€' },
          { id: 4, name: '2.000.000,00€' },
          { id: 5, name: 'Massimale Libero' },
        ],
      },
      {
        id: 2,
        name: 'Categoria Rischio',
        key: 'risk_value',
        values: [
          { id: 'A', name: 'Categoria Rischio A' },
          { id: 'B', name: 'Categoria Rischio B' },
          { id: 'C', name: 'Categoria Rischio C' },
          { id: 'R', name: 'Rischio Di Direzione' },
        ],
      },
    ],
  },
  {
    id: 'FABB',
    name: 'Incendio Fabbricato',
    parameter_collections: [
      {
        id: 1,
        name: 'Categoria Rischio',
        key: 'risk_value',
        values: [
          { id: 'A', name: 'Categoria Rischio A' },
          { id: 'B', name: 'Categoria Rischio B' },
          { id: 'C', name: 'Categoria Rischio C' },
          { id: 'D', name: 'Categoria Rischio D' },
          { id: 'R', name: 'Rischio Di Direzione' },
        ],
      },
      {
        id: 2,
        name: 'Condizioni Aggiuntive',
        key: 'additional_conditions',
        values: [
          { id: 1, name: 'Nessuna' },
          { id: 2, name: 'Sociopolitici' },
          { id: 3, name: "Indennita' Aggiuntiva" },
          { id: 4, name: "Sociopolitici + Indennita' Aggiuntiva" },
        ],
        default_value: 1,
      },
      {
        id: 3,
        key: 'building_age',
        name: "Vetusta' Fabbricato",
        values: [
          { id: 1, name: 'Uguale/Inferiore 5 Anni' },
          { id: 2, name: 'Superiore 5 Anni' },
        ],
      },
    ],
  },
  {
    id: 'CONT',
    name: 'Incendio Contenuto',
    parameter_collections: [
      {
        id: 1,
        name: 'Categoria Rischio',
        key: 'risk_value',
        values: [
          { id: 'A', name: 'Categoria Rischio A' },
          { id: 'B', name: 'Categoria Rischio B' },
          { id: 'C', name: 'Categoria Rischio C' },
          { id: 'D', name: 'Categoria Rischio D' },
          { id: 'R', name: 'Rischio Di Direzione' },
        ],
      },
      {
        id: 2,
        name: 'Condizioni Aggiuntive',
        key: 'additional_conditions',
        values: [
          { id: 1, name: 'Nessuna' },
          { id: 2, name: 'Sociopolitici' },
          { id: 3, name: "Indennita' Aggiuntiva" },
          { id: 4, name: "Sociopolitici + Indennita' Aggiuntiva" },
        ],
        default_value: 1,
      },
    ],
  },
  {
    id: 'RILO',
    name: 'Rischio Locativo',
    parameter_collections: [
      {
        id: 1,
        name: 'Categoria Rischio',
        key: 'risk_value',
        values: [
          { id: 'A', name: 'Categoria Rischio A' },
          { id: 'B', name: 'Categoria Rischio B' },
          { id: 'C', name: 'Categoria Rischio C' },
          { id: 'D', name: 'Categoria Rischio D' },
          { id: 'R', name: 'Rischio Di Direzione' },
        ],
      },
    ],
  },
  {
    id: 'RTER',
    name: 'Ricorso Terzi',
    parameter_collections: [
      {
        id: 1,
        name: 'Categoria Rischio',
        key: 'risk_value',
        values: [
          { id: 'A', name: 'Categoria Rischio A' },
          { id: 'B', name: 'Categoria Rischio B' },
          { id: 'C', name: 'Categoria Rischio C' },
          { id: 'D', name: 'Categoria Rischio D' },
          { id: 'R', name: 'Rischio Di Direzione' },
        ],
      },
    ],
  },
  {
    id: 'REFR',
    hidden: true,
    name: 'Merci Refrigerazione',
    parameter_collections: [
      {
        id: 2,
        name: 'Condizioni Aggiuntive',
        key: 'additional_conditions',
        values: [
          { id: 1, name: 'Nessuna' },
          { id: 2, name: 'Sociopolitici' },
          { id: 3, name: "Indennita' Aggiuntiva" },
          { id: 4, name: "Sociopolitici + Indennita' Aggiuntiva" },
        ],
        default_value: 1,
      },
    ],
  },
  {
    id: 'CRIS',
    hidden: true,
    name: 'Cristalli',
    parameter_collections: [
      {
        id: 2,
        name: 'Condizioni Aggiuntive',
        key: 'additional_conditions',
        values: [
          { id: 1, name: 'Nessuna' },
          { id: 2, name: 'Sociopolitici' },
          { id: 3, name: "Indennita' Aggiuntiva" },
          { id: 4, name: "Sociopolitici + Indennita' Aggiuntiva" },
        ],
        default_value: 1,
      },
    ],
  },
  // {
  //   id: 'ADB',
  //   name: 'ALTRI DANNI AI BENI TARIFFA BIDONE',
  //   parameter_collections: [],
  // },
  // {
  //   id: 'INC',
  //   name: 'INCENDIO TARIFFA BIDONE',
  //   parameter_collections: [],
  // },
  // {
  //   id: 'TERR',
  //   name: 'TERREMOTO',
  //   parameter_collections: [],
  // },
  // {
  //   id: 'TEAL',
  //   name: 'TERREMOTO E ALLUVIONE',
  //   parameter_collections: [],
  // },
  {
    id: 'CONT.F',
    name: 'Furto Contenuto',
    parameter_collections: [
      {
        id: 1,
        name: 'Categoria Rischio',
        key: 'risk_value',
        values: [
          { id: 'A', name: 'Categoria Rischio A' },
          { id: 'B', name: 'Categoria Rischio B' },
          { id: 'C', name: 'Categoria Rischio C' },
          { id: 'D', name: 'Categoria Rischio D' },
          { id: 'R', name: 'Rischio Di Direzione' },
        ],
      },
      {
        id: 4,
        key: 'zona_territoriale',
        name: 'Zona Territoriale',
        values: [
          { id: 1, name: 'Zona 1' },
          { id: 2, name: 'Zona 2' },
          { id: 3, name: 'Zona 3' },
          { id: 4, name: 'Zona 4' },
          { id: 5, name: 'Zona 5' },
        ],
      },
      {
        id: 5,
        name: 'Presenza Impianto Allarme',
        values: [
          { id: 1, name: 'Si' },
          { id: 2, name: 'No' },
        ],
      },
      {
        id: 6,
        name: 'Richiesta Deroga Rischio Direzione',
        values: [
          { id: 1, name: 'Si' },
          { id: 2, name: 'No' },
        ],
      },
    ],
  },
  // commented because cant be selected with rct and we always need rct selected
  // {
  //   id: 'PROP',
  //   name: "RCT Propieta' Del Fabbricato",
  //   parameter_collections: [
  //     {
  //       id: 1,
  //       name: 'Massimale',
  //       values: [
  //         { id: 1, name: '500.000,00€' },
  //         { id: 2, name: '1.000.000,00€' },
  //         { id: 3, name: '1.500.000,00€' },
  //         { id: 4, name: '2.000.000,00€' },
  //         { id: 5, name: 'Massimale Libero' },
  //       ],
  //     },
  //   ],
  // },
  {
    id: 'ELE',
    name: 'Elettronica Impresa e Artigiano',
    parameter_collections: [],
  },
  // { //? DOUBLE CHECK THIS
  //   id: 'INCI',
  //   name: 'Assistenza Impresa e Artigiano',
  //   parameter_collections: [],
  // },
];

export const evaluateConditions = (conditions = [], watch = () => { }) => {
  if (!conditions.length) return true;
  return conditions.every((cond) => {
    const fieldValue = watch(cond.field);
    switch (cond.type) {
      case 'eq':
        return fieldValue === cond.value;
      case 'neq':
        return fieldValue !== cond.value;
      case 'in':
        return Array.isArray(cond.value)
          ? cond.value.includes(fieldValue)
          : false;
      case 'nin':
        return Array.isArray(cond.value)
          ? !cond.value.includes(fieldValue)
          : false;
      default:
        return true;
    }
  });
};

export const vatNumberValidationSchema = yup.object({
  vat_number: yup
    .string()
    .max(11, 'La partiva iva non puo essere piu di 11 numeri!')
    .matches(/^[0-9]*$/, 'Solo numeri sono ammessi!')
    .required('Il campo è obbligatorio. Inserisci la tua partita iva!'),
});

export const commercialCompanyDataSchema = yup.object({
  vat_number: yup
    .string()
    .min(11, 'La partiva iva deve essere di 11 numeri!')
    .max(11, 'La partiva iva non puo essere piu di 11 numeri!')
    .matches(/^[0-9]*$/, 'Solo numeri sono ammessi!')
    .required('Il campo è obbligatorio. Inserisci la tua partita iva!'),
  number_of_employees: yup
    .number('Deve essere un numero')
    .transform((value, originalValue) => (String(originalValue).trim() === '' ? null : value))
    .required('Il campo è obbligatorio. Inserisci numero di dipendenti!')
    .test(
      'is-number-and-positive',
      'Deve essere un numero e maggiore di 0',
      (value) => value === null || (typeof value === 'number' && value > 0),
    ),
  attpr_value: yup
    .string()
    .required("Il campo è obbligatorio. Inserisci l'attività Principale Value!"),
  turnover_value: yup
    .number('Deve essere un numero')
    .transform((value, originalValue) => (String(originalValue).trim() === '' ? null : value))
    .required('Il campo è obbligatorio. Inserisci Valore del Fatturato!')
    .test(
      'is-number-and-positive',
      'Deve essere un numero e maggiore di 0',
      (value) => value === null || (typeof value === 'number' && value > 0),
    ),
  payment_frequency: yup
    .string()
    .required('Il campo è obbligatorio. Seleziona la Payment Frequency!')
    .oneOf([2, 3, '2', '3'], 'Seleziona una Payment Frequency valida!'),
  address: yup.object({
    address: yup
      .string()
      .required("Il campo è obbligatorio. Inserisci l'indirizzo!"),
    house_number: yup
      .string()
      .required('Il campo è obbligatorio. Inserisci il numero civico!'),
    postal_code: yup
      .string()
      .required('Il campo è obbligatorio. Inserisci il CAP!')
      .matches(/^[0-9]{5}$/, 'Il codice postale non e coretto'),
    municipality_name: yup
      .string()
      .required('Il campo è obbligatorio. Inserisci il Comune!'),
    province_code: yup
      .string()
      .required('Il campo è obbligatorio. Inserisci la Provincia!'),
    ministerial_municipality_code: yup
      .string()
      .required('Il campo è obbligatorio. Seleziona provincia di residenza!'),
  }),
  effective_date: yup
    .string()
    .required('Il campo è obbligatorio. Inserisci la Data di Decorrenza!')
    .test(
      'is-today-or-future',
      'La data deve essere oggi o una data futura',
      (value) => {
        if (!value) return false;
        const inputDate = new Date(value);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        inputDate.setHours(0, 0, 0, 0);
        return inputDate >= today;
      },
    ),
  payment_frequency_value: yup
    .string()
    .required('Il campo è obbligatorio. Seleziona la frequenza di pagamento!'),
});

export const commercialTechnicalDataSchema = yup.object({
  technical_location_data: yup.object({
    annor_value: yup
      .number('Deve essere un numero')
      .transform((value, originalValue) => (String(originalValue).trim() === '' ? null : value))
      .required('Il campo è obbligatorio. Inserisci il anno di ricostruzione!')
      .test(
        'is-number-and-positive',
        'Deve essere un numero e maggiore di 0',
        (value) => value === null || (typeof value === 'number' && value > 0),
      ),
    annoc_value: yup
      .number('Deve essere un numero')
      .transform((value, originalValue) => (String(originalValue).trim() === '' ? null : value))
      .required('Il campo è obbligatorio. Inserisci il anno di costruzione!')
      .test(
        'is-number-and-positive',
        'Deve essere un numero e maggiore di 0',
        (value) => value === null || (typeof value === 'number' && value > 0),
      ),
    tpab_value: yup
      .string()
      .required('Il campo è obbligatorio. Inserisci il tipo fabbricato Value!'),
    attpr_value: yup
      .string()
      .required(
        "Il campo è obbligatorio. Inserisci l'attività Principale Value!",
      ),
  }),
  property_value: yup
    .number('Deve essere un numero')
    .transform((value, originalValue) => (String(originalValue).trim() === '' ? null : value))
    .required('Il campo è obbligatorio. Inserisci Valore Immobile!')
    .test(
      'is-number-and-positive',
      'Deve essere un numero e maggiore di 0',
      (value) => value === null || (typeof value === 'number' && value > 0),
    ),
  coverages: yup
    .array()
    .of(
      yup.object({
        coverage_code: yup
          .string()
          .required('Il campo è obbligatorio. Seleziona la garanzia!'),
        parameter_collections: yup
          .array()
          .of(
            yup.object({
              parameter_sequence: yup
                .string()
                .required('Il campo è obbligatorio. Seleziona il progressivo!'),
              parameter_value_code: yup
                .string()
                .required(
                  'Il campo è obbligatorio. Inserisci il valore del progressivo!',
                ),
            }),
          )
          .optional(),
        max_amount: yup
          .mixed()
          .transform((value, originalValue) => {
            if (originalValue === undefined || originalValue === null || String(originalValue).trim() === '') return null;
            return value;
          })
          .nullable()
          // Change from .when() to using .test()
          .test('max_amount_required', 'Il campo è obbligatorio. Inserisci il Massimale per la garanzia selezionata!', function (value) {
            const { coverage_code } = this.parent;

            // If coverage code is in the exclusion list, max_amount is optional
            if (['INCI', 'RCT', 'PROP'].includes(coverage_code)) {
              return true; // Always valid for these coverages
            }

            // For other coverages, value must be a valid number > 0
            if (value === null || value === undefined || value === '') {
              return false;
            }

            const numValue = Number(value);
            return !Number.isNaN(numValue) && numValue > 0;
          })
          .test('max_amount_number', 'Deve essere un numero', function (value) {
            const { coverage_code } = this.parent;

            // If coverage code is in exclusion list or value is empty/null, validation passes
            if (['INCI', 'RCT', 'PROP'].includes(coverage_code) || value === null || value === undefined || value === '') {
              return true;
            }

            // Otherwise check if it's a valid number
            const numValue = Number(value);
            return !Number.isNaN(numValue);
          })
          .test('max_amount_positive', 'Il Massimale deve essere maggiore di zero!', function (value) {
            const { coverage_code } = this.parent;

            // If coverage code is in exclusion list or value is empty/null, validation passes
            if (['INCI', 'RCT', 'PROP'].includes(coverage_code) || value === null || value === undefined || value === '') {
              return true;
            }

            // Otherwise check if it's > 0
            const numValue = Number(value);
            return numValue > 0;
          }),
      }),
    )
    .min(1, 'Devi selezionare almeno una garanzia!'),
});

export const personalDataSchema = yup.object({
  gender: yup.string().required('Il campo è obbligatorio. Seleziona genere!'),
  company_name: yup
    .string()
    .nullable()
    .when('gender', {
      is: 'G',
      then: () => yup
        .string()
        .required("Il campo è obbligatorio. Inserisci il nome dell'azienda!"),
    }),
  phone: yup
    .string()
    .required('Il campo è obbligatorio. Inserisci numero di telefono!')
    .matches(/^[3]{1}[0-9]{8,9}$/, 'Il numero non e corretto'),
  email: yup
    .string()
    .matches(
      /^[a-zA-Z0-9.@]+$/,
      'Sono ammessi solo lettere (a-z), numeri (0-9), punti (.) e (@).',
    )
    .required('Il campo è obbligatorio. Inserisci Email!')
    .email('Deve essere un email valido! Rimouvi spazi vuoti!'),
  privacies: yup.array(yup.number()),
});

export const needsQuestionareSchema = yup.object({
  complete_questionario: yup.boolean().required('Il campo è obbligatorio. Seleziona un opzione!'),
});

export const commercial_main_risks = {
  '001CAA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '002CBB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '003CAB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '004ADB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'A',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'A',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'A',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'A',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '005ABB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'A',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'A',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'A',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'A',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '006CDB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '007CAA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '008CAA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '009BDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '010BCA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '011DCA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'D',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'D',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'D',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'D',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '012CBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '013AAA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'A',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'A',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'A',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'A',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '014DAB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'D',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'D',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'D',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'D',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '015CAB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '016CCA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '017CDB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '018CDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '019CBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '020CAA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '021ACA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'A',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'A',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'A',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'A',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '022BBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '023BBB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '024BDB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '025CCA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '026DAA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'D',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'D',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'D',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'D',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '027CDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '028CAA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '029CBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '030BDB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '031ACB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'A',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'A',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'A',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'A',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '032ACA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'A',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'A',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'A',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'A',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '033CDB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '034CCB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '035BCA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '036CAA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '037CBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '038CBB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '039CAA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '040DBB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'D',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'D',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'D',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'D',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '042BBB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '043CBB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '044CDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '045CDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '046BBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '047BCA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '048CAA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '049BCA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '050BCA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '051CCB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '052BCB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '053CBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '054CDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '055BBB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '056CDB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '057CBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '058BBB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '059BCA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '060CDB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '061CDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '062CBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '063BDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '064CAA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '065BBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '066BDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '067CCA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '068CBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '069DDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'D',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'D',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'D',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'D',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '070BBB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '071CBB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '072CBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '073CBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '074CAA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '075CBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '076CAA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '077BCA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '078DCB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'D',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'D',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'D',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'D',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '079BDB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '080CBB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '081BCA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '082CDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '083CAA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '084CBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '085DDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'D',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'D',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'D',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'D',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '086BBB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '087BCB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '088CBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '089BDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '090BBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '091CBB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '092BCA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '093BCB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '094DCA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'D',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'D',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'D',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'D',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '095BXA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: ['R', 'D'],
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '096CDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '097CDB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '098CDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '099CBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '100BCA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '101ACA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'A',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'A',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'A',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'A',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '102BDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '103CDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '104CCB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '105BCB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '106CBC': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '107BDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '108CAA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '109CCA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '110BAA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '111BBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '112BBB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '113BDB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '114BDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '115ABB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'A',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'A',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'A',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'A',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '116CAA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '117ACB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'A',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'A',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'A',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'A',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '118DDB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'D',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'D',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'D',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'D',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '119ADA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'A',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'A',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'A',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'A',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '120DCB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'D',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'D',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'D',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'D',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '121CAA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '122CBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '123CAC': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'C',
    },
  },
  '124ADA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'A',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'A',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'A',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'A',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '125CCB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '126ADB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'A',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'A',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'A',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'A',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '127DBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'D',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'D',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'D',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'D',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '128CBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '129CCB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '130CCB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '131DCA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'D',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'D',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'D',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'D',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '132BXA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: ['R', 'D'],
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '133CDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '134BBB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '135CCB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '136ACA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'A',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'A',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'A',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'A',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '137BDB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '138BCB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '139BCB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '140CCB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '141BCA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '142CAA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '143CXA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: ['R', 'D'],
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '144ADB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'A',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'A',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'A',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'A',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '145CBB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '146DBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'D',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'D',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'D',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'D',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '147BBB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '148DCA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'D',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'D',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'D',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'D',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '149ACB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'A',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'A',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'A',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'A',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '150CBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '151CDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '152CBB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '153CBB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '154CCA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '155BCA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '156CBB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '157BCA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '158CAA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '159CAA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '160BDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '161DDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'D',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'D',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'D',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'D',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '162ADA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'A',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'A',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'A',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'A',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '163BCA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '164BDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '165CBC': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'C',
    },
  },
  '166CAA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '167CBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '168CBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '169BBB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '170CXA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: ['R', 'D'],
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '171CBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '172CBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '173CDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '174CBB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '175CBB': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'B',
    },
  },
  '176BBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '177CAA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'A',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '178DDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'D',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'D',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'D',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'D',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '179RDA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'R',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'R',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'R',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'D',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'D',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '180CBA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'C',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'C',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'C',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'C',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'B',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
  '181BCA': {
    FABB: {
      risk_category: 'incendio_fabricato',
      risk_value: 'B',
    },
    RILO: {
      risk_category: 'ricorso_locatario',
      risk_value: 'B',
    },
    RTER: {
      risk_category: 'ricorso_terzi',
      risk_value: 'B',
    },
    CONT: {
      risk_category: 'incendio_contenuto',
      risk_value: 'B',
    },
    'CONT.F': {
      risk_category: 'furto_contenuto',
      risk_value: 'C',
    },
    RCT: {
      risk_category: 'responsabilita_civile_terzi',
      risk_value: 'A',
    },
  },
};

export const communal_territories_default_values = {
  // Andria Barletta Trani
  BT: '1',
  // Agrigento
  AG: '4',
  // Alessandria
  AL: '4',
  // Ancona
  AN: '4',
  // Aosta
  AO: '5',
  // Arezzo
  AR: '4',
  // Ascoli Piceno
  AP: '4',
  // Asti
  AT: '4',
  // Avellino
  AV: '4',
  // Bari
  BA: '1',
  // Belluno
  BL: '5',
  // Benevento
  BN: '5',
  // Bergamo
  BG: '4',
  // Biella
  BI: '4',
  // Bologna
  BO: '3',
  // Bolzano
  BZ: '5',
  // Brescia
  BS: '4',
  // Brindisi
  BR: '2',
  // Cagliari
  CA: '4',
  // Caltanissetta
  CL: '4',
  // Campobasso
  CB: '4',
  // Caserta
  CE: '3',
  // Catania
  CT: '1',
  // Catanzaro
  CZ: '4',
  // Chieti
  CH: '4',
  // Como
  CO: '4',
  // Cosenza
  CS: '4',
  // Cremona
  CR: '4',
  // Crotone
  KR: '4',
  // Cuneo
  CN: '4',
  // Enna
  EN: '5',
  // Fermo
  FM: '5',
  // Ferrara
  FE: '4',
  // Firenze
  FI: '4',
  // Foggia
  FG: '3',
  // Forlì-Cesena
  FC: '2',
  // Frosinone
  FR: '4',
  // Genova
  GE: '4',
  // Gorizia
  GO: '5',
  // Grosseto
  GR: '4',
  // Imperia
  IM: '5',
  // Isernia
  IS: '5',
  // La spezia
  SP: '4',
  // L'Aquila
  AQ: '4',
  // Latina
  LT: '3',
  // Lecce
  LE: '2',
  // Lecco
  LC: '4',
  // Livorno
  LI: '4',
  // Lodi
  LO: '3',
  // Lucca
  LU: '4',
  // Macerata
  MC: '5',
  // Mantova
  MN: '4',
  // Massa-Carrara
  MS: '4',
  // Matera
  MT: '5',
  // Messina
  ME: '1',
  // Milano
  MI: '2',
  // Modena
  MO: '4',
  // Monza e della Brianza
  MB: '2',
  // Napoli
  NA: '1',
  // Novara
  NO: '4',
  // Nuoro
  NU: '4',
  // Oristano
  OR: '5',
  // Padova
  PD: '2',
  // Palermo
  PA: '2',
  // Parma
  PR: '4',
  // Pavia
  PV: '4',
  // Perugia
  PG: '4',
  // Pesaro e Urbino
  PU: '4',
  // Pescara
  PE: '4',
  // Piacenza
  PC: '4',
  // Pisa
  PI: '4',
  // Pistoia
  PT: '4',
  // Pordenone
  PN: '4',
  // Potenza
  PZ: '4',
  // Prato
  PO: '4',
  // Ragusa
  RG: '4',
  // Ravenna
  RA: '4',
  // Reggio di Calabria
  RC: '4',
  // Reggio nell'Emilia
  RE: '4',
  // Rieti
  RI: '4',
  // Rimini
  RN: '2',
  // Roma
  RM: '1',
  // Rovigo
  RO: '4',
  // Salerno
  SA: '2',
  // Sassari
  SS: '4',
  // Savona
  SV: '4',
  // Siena
  SI: '4',
  // Siracusa
  SR: '2',
  // Sondrio
  SO: '5',
  // Taranto
  TA: '2',
  // Teramo
  TE: '4',
  // Terni
  TR: '4',
  // Torino
  TO: '2',
  // Trapani
  TP: '2',
  // Trento
  TN: '4',
  // Treviso
  TV: '2',
  // Trieste
  TS: '5',
  // Udine
  UD: '4',
  // Varese
  VA: '3',
  // Venezia
  VE: '2',
  // Vercelli
  VC: '4',
  // Verona
  VR: '2',
  // Vibo Valentia
  VV: '4',
  // Vicenza
  VI: '4',
  // Viterbo
  VT: '4',
  // Verbania
  VB: '4',
  // Sud Sardegna
  SU: '4',
};
